export default "__VITE_ASSET__dp9CBmeQ__"